import type { InferOutput } from "valibot";

declare global { const wishlist: Wishlist; }

export const wishlistSchema = v.object({
  products: v.array(productDocumentSchema),
});
export type Wishlist = InferOutput<typeof wishlistSchema>;

export const toggleWishlistSchema = v.object({
  product_id: v.number(),
});
export type ToggleWishlist = InferOutput<typeof toggleWishlistSchema>;
